import { render } from "./Socialphoto.vue?vue&type=template&id=78252eed&scoped=true"
import script from "./Socialphoto.vue?vue&type=script&lang=js"
export * from "./Socialphoto.vue?vue&type=script&lang=js"

import "./Socialphoto.vue?vue&type=style&index=0&id=78252eed&lang=scss&scoped=true"

import exportComponent from "C:\\__MRYNK\\_2022\\beweegminuut\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78252eed"]])

export default __exports__